import React from 'react';
import clsx from 'clsx';
import Box from '@mui/material/Box';
import { IUserCreateComplexes } from 'src/typings/usersManage';
import { ComplexStatus } from 'src/components/profileComponents/ComplexStatus';
import { ComplexStatusRoundingDirection, ComplexStatusState } from 'src/constants/complexStatus';
import { useStyles } from './styles';

interface IProjectProps {
  project: IUserCreateComplexes,
  isChecked: (project: IUserCreateComplexes) => boolean;
  toggleProject: (project: IUserCreateComplexes) => void;
}
export const Project: React.FC<IProjectProps> = ({ project, isChecked, toggleProject }) => {
  const styles = useStyles();
  return (
    <Box
      className={`${styles.project} ${clsx(isChecked(project) && 'checked')}`}
      key={project.id}
      onClick={() => toggleProject(project)}
    >
      <div className="project-wrapper">
        <div className="project-action">
          <span className="checkbox-wrapper">
            <input type="checkbox" name="checkbox" className={clsx(isChecked(project) && 'checked')} />
            <span className="custom-checkbox" />
          </span>
          {project.title && (
            <div className="title">{project.title}</div>
          )}
        </div>
        <div className="complex-status">
          <ComplexStatus complexStatus={project.status} state={ComplexStatusState.DEFAULT} roundingDirection={ComplexStatusRoundingDirection.RIGHT} />
        </div>
      </div>
    </Box>
  );
};
